import { getApiBaseUrl } from '../config/apiConfig';
import type { ApiConfig, HookRequest, MakeTokenParams, ReservationApiClient } from '../types/api';
import { isDevelopment } from '../utils/environment';
import { BaseApiClient } from './apiClient';

/**
 * Service for managing meeting tokens and reservations
 */
export class ReservationService extends BaseApiClient implements ReservationApiClient {
  constructor(config?: Partial<ApiConfig>) {
    const isDevMode = isDevelopment();

    super({
      baseUrl: getApiBaseUrl(isDevMode),
      ...config,
    });
  }

  /**
   * Generate a JWT token for a meeting room
   * If no reservation exists for the room, one will be created automatically
   */
  async generateToken(params: MakeTokenParams): Promise<string> {
    const response = await this.post<string>('/reservation/app/token', params);
    return response.data;
  }

  /**
   * Handle meeting room hooks
   * Processes hook requests for meeting room events
   * When all events for a room are fully processed, the corresponding reservation is deleted
   */
  async handleHook(request: HookRequest): Promise<void> {
    await this.post<void>('/reservation/hooks/request', request);
  }
}

// Create singleton instance
export const reservationService = new ReservationService();
